export enum GamesSliderGroup {
  Popular = 'Popular',
  New = 'New',
}
